import styled from "styled-components";
import SwapArrow from "../witadmin/icons/swapArrow";

export const StyledSwapArrow = styled(SwapArrow)`
  height: 14px;
  width: 14px;
`;

export const StyledEllipsisCell = styled.div`
  display: block;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
